import type { IconProps } from "@tamagui/helpers-icon";
import { Users } from "@tamagui/lucide-icons";
import { useTranslation } from "react-i18next";
import { XStack } from "tamagui";
import { Body } from "../../../ui/Body";

export const BusinessIcon = ({
  type,
  ...props
}: { type: "team" | "customer" } & IconProps) => {
  const { t } = useTranslation();

  const p: IconProps = {
    size: "$small",
    color: "$pressablePrimaryBackground",
    ...props,
  };

  if (type === "team")
    return (
      <XStack gap={"$small"} alignItems="center">
        <Users {...p} />
        <Body color={p.color}>{t("business:team")} - </Body>
      </XStack>
    );

  //  : <StarFull {...p} />;
  return null;
};
